import type { DialogSizePreset } from '@uefadigital/panenka';

import GoogleTagManagerHelper from '@tracking/gtm-helper';
import { debounce } from '@utilities/throttle';

export type PkDialogOptions = {
  changeDialogSizeOnResize?: boolean;
  // JS example: {0: 'full', 960: 'large'}
  // C# example: new Dictionary<string, string> { { "0", "full" }, { "960", "large" } }
  widthsToPkSize?: { [key: number]: DialogSizePreset };
  closeTracking?: Record<string, any>;
  openTracking?: Record<string, string>;
};

export default class PkDialogPlugin {
  options: PkDialogOptions;
  dom: HTMLPkDialogElement;

  constructor(e: HTMLPkDialogElement, o: PkDialogOptions) {
    const defaults: PkDialogOptions = {};

    this.dom = e;
    this.options = { ...defaults, ...o };
  }

  init() {
    if (this.options.changeDialogSizeOnResize) {
      window.addEventListener('resize', this.resizePkDialog);
      this.resizePkDialog();
    }

    if (this.options.closeTracking) {
      this.dom.addEventListener('pkClose', () => {
        const { category, action, label, more } = this.options.closeTracking;
        GoogleTagManagerHelper.event(category, action, label, more);
      });
    }

    if (this.options.openTracking) {
      this.dom.addEventListener('pkOpen', () => {
        GoogleTagManagerHelper.addVirtualPage(this.options.openTracking);
      });
    }
  }

  resizePkDialog = debounce(() => {
    const windowWidth = screen.availWidth;
    const widths = Object.keys(this.options.widthsToPkSize)
      .map((s) => Number.parseInt(s))
      .filter((s) => !Number.isNaN(s))
      .toSorted((p1, p2) => (p1 > p2 ? 1 : -1));
    const actualWidth = widths.reduce((prev, curr) => (windowWidth > curr ? curr : prev), 0);
    this.dom.size = this.options.widthsToPkSize[actualWidth];
  }, 250);
}
